import { patternRegistry, isValidPattern } from './BackgroundPatternSvgs';

/**
 * BackgroundPatterns - Class untuk mengelola SVG patterns untuk background
 * Mendukung berbagai jenis pattern: tech, cakes, dots, grid, geometric, custom
 */
export class BackgroundPatterns {
  constructor(primaryColor) {
    this.primaryColor = primaryColor;
    this.darkColor = this.darkenColor(primaryColor, 25);
  }

  /**
   * Darken color by percentage
   * @param {string} color - Color in hex or rgb format
   * @param {number} percent - Percentage to darken (0-100)
   * @returns {string} - Darkened color in rgb format
   */
  darkenColor(color, percent = 25) {
    let r, g, b;
    
    if (color.startsWith('#')) {
      const hex = color.replace('#', '');
      r = parseInt(hex.substring(0, 2), 16);
      g = parseInt(hex.substring(2, 4), 16);
      b = parseInt(hex.substring(4, 6), 16);
    } else if (color.startsWith('rgb')) {
      const match = color.match(/\d+/g);
      [r, g, b] = match.map(Number);
    } else {
      return color;
    }
    
    // Darken by percentage
    r = Math.max(0, Math.floor(r * (1 - percent / 100)));
    g = Math.max(0, Math.floor(g * (1 - percent / 100)));
    b = Math.max(0, Math.floor(b * (1 - percent / 100)));
    
    return `rgb(${r}, ${g}, ${b})`;
  }

  /**
   * Get pattern by type
   * @param {string} type - Pattern type (tech, cakes, dots, grid, geometric, custom)
   * @param {string} customUrl - URL for custom background image (only used if type is 'custom')
   * @returns {JSX.Element|null} - SVG pattern element or null for custom
   */
  getPattern(type = 'cakes', customUrl = null) {
    // Jika type adalah 'custom', return null karena kita akan handle dengan CSS
    if (type === 'custom') {
      return null;
    }
    
    // Check if pattern exists in registry
    if (!isValidPattern(type)) {
      console.warn(`Pattern type "${type}" not found. Using default "cakes" pattern.`);
      type = 'cakes';
    }

    // Get pattern component from registry
    const PatternComponent = patternRegistry[type];
    
    // Return pattern with colors
    return (
      <PatternComponent 
        primaryColor={this.primaryColor} 
        darkColor={this.darkColor} 
      />
    );
  }

  /**
   * Generate background style object
   * @param {string} type - Pattern type
   * @param {string} customUrl - URL for custom background image
   * @returns {Object} - Style object for background
   */
  getBackgroundStyle(type = 'cakes', customUrl = null) {
    const baseStyle = {
      position: 'relative',
      backgroundColor: '#f5f5f5',
    };

    // Jika type adalah 'custom' dan ada customUrl
    if (type === 'custom' && customUrl) {
      return {
        ...baseStyle,
        backgroundImage: `url(${customUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      };
    }

    // Untuk pattern lainnya
    return {
      ...baseStyle,
      backgroundImage: 'none',
    };
  }
}

export default BackgroundPatterns;